export const TOOLTIP =
  'This is a subscription report. To manage your subscriptions visit settings.'
